export default "/kiban/_next/static/images/hide-942464b1a367e9746cea34f49704332f.svg";